import { render, staticRenderFns } from "./InfoBooth.vue?vue&type=template&id=5a23811e&scoped=true&"
import script from "./InfoBooth.vue?vue&type=script&lang=js&"
export * from "./InfoBooth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a23811e",
  null
  
)

export default component.exports